const debug = process.env.API_DEV || false;
const DEBUG_SERVER = 'http://localhost:5002/api';

const SERVER = debug ? DEBUG_SERVER : '/api';

if (debug) console.log('API SERVER [' + SERVER + ']'); // eslint-disable-line

export default {
  'OSS': 'https://oss.umiuni.com/',
  'user': {
    'login': SERVER + '/user/login',
    'getInfo': SERVER + '/user/get',
    'updateInfo': SERVER + '/user/set',
    'preRegister': SERVER + '/user/pre_register',
    'preRegisterGeneric': SERVER + '/user/pre_register_generic',
    'register': SERVER + '/user/register',
    'user_signin': SERVER + '/user/user_signin',
    'verifyEmail': SERVER + '/user/verify_email',
    'verifyEmailGeneric': SERVER + '/user/verify_email_generic',
    'verifySession': SERVER + '/user/verify_session',
    'forgetPassword': SERVER + '/user/forget_password',
  },
  'school': {
    'list': SERVER + '/school/list',
  },
  'tag': {
    'list': SERVER + '/tag/list',
    'type': SERVER + '/tag/type',
  },
  'subject': {
    'list': SERVER + '/subject/list',
  },
  'item': {
    'publish': SERVER + '/item/set',
    'list': SERVER + '/item/list',
    'getInfo': SERVER + '/item/get',
  },
  'file': {
    'upload': SERVER + '/file/upload',
  },
  'manage': {
    'list': SERVER + '/item/private_list',
  },
  'like': {
    'list': SERVER + '/like/list',
    'add': SERVER + '/like/add',
    'del': SERVER + '/like/del',
  },
  'secure': {
    'set': SERVER + '/secure/set',
    'list': SERVER + '/secure/list',
    'get': SERVER + '/secure/get',
  },
  'message': {
    'get': SERVER + '/message/get',
    'send': SERVER + '/message/send',
    'list': SERVER + '/message/list',
  },
  'forum': {
    'list': SERVER + '/forum',
    'post': {
      'list': SERVER + '/forum/list_post',
      'set': SERVER + '/forum/set_post',
      'up': SERVER + '/forum/set_thumb',
    },
    'topic': {
      'list': SERVER + '/forum/list_topic',
      'set': SERVER + '/forum/set_topic',
      'delete': SERVER + '/forum/del_topic',
    },
    'info': {
      'get': SERVER + '/forum/get_fake_info',
      'set': SERVER + '/forum/set_fake_info',
    },
  },
  'slide': {
    'list': SERVER + '/slide/list',
  },
};



// WEBPACK FOOTER //
// ./src/api.js